import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
 checkCustomerLimitsSuccessAction
} from './Actions';
import {
  newErrorNotificationAction,
  newSuccessNotificationAction,
  errorNotificationFromError,
} from '../notifications/Actions';
import * as api from './Api';

import { push } from 'connected-react-router';
import { setRedirectFalse, setRedirectTrue } from '../globalFail/Action';


function* checkCustomerLimits({payload}) {
  yield put(checkCustomerLimitsSuccessAction(false))
  try {
    const response = yield call(api.checkCustomerLimits, payload)
    console.log(response)
    // yield put(checkCustomerLimitsSuccessAction(response))
  } catch(error) {

    yield put(newErrorNotificationAction(error))
  } 
}

export default function*() {
  yield takeLatest(actions.CHECK_CUSTOMER_LIMITS, checkCustomerLimits);

}
